export const englishTexts = {
    or: 'or',
    // Map Search
    mapSearchPlaceholder: 'Enter keyword with AND or OR',
    search: 'Search',
    results: 'results',
    noResults: 'We couldn\'t find any results. Please try again.',
    viewMoreResults: 'View more results',
    advancedSearch: 'Advanced Search',
    startsWith: 'Starts with',
    contains: 'Contains',
    businessCategory: 'Business Category',
    numericRange: 'Numeric Range',
    fmz: 'Zone',
    transitId: 'Client ID',
    locationId: 'Location ID',
    searchText: 'Search keywords with "AND" & "OR"',
    adminDashboard: 'Admin Dashboard',
    assignedLocations: 'Assigned Locations',

    // ImageUploader
    imageUploader: {
        instruction: 'Drag and Drop Image here',
        finePrint: 'Image size is limited to 4MB.\n' +
          'Image between 200KB & 4MB size will be compressed.',
        heading: 'Upload Image',
        subHeading: 'Please upload image below',
        oversizeError: 'Error: The image size is too large'
    },

    // Button
    buttons: {
        chooseImage: 'Choose Image'
    }
}

export const texts = englishTexts